<template>
  <div class="admin-start-hub__card admin-start-hub__tickets">
    <div>
      <div class="admin-start-hub__card-label">
        <span class="admin-start-hub__dot" aria-hidden="true"></span>
        <span>{{ card.label }}</span>
      </div>
      <p class="admin-start-hub__count">{{ formattedCount }}</p>
    </div>
    <a class="admin-start-hub__cta" :href="card.href">
      {{ ctaLabel }}
      <i class="fa fa-arrow-right" aria-hidden="true"></i>
    </a>
  </div>
</template>

<script>
export default {
  name: 'StartHubTicketsCard',
  props: {
    card: { type: Object, required: true },
    ctaLabel: { type: String, required: true },
  },
  computed: {
    formattedCount() {
      return Number(this.card.count || 0).toLocaleString('it-IT');
    },
  },
};
</script>
